import { AsGuestModal, axios, Core, Env, LoginModal, RegisterModal } from "@ancademy/vse-client";
import { ABU, Color, Md, Style } from "@client";
import { css, cx } from "@emotion/css";
import { IHomeStat } from "@share";
import { Modal } from "antd";
import { transparentize } from "polished";
import React, { useEffect, useState } from "react";
import style from "./style.scss";

export function Login({}: Core.ILoginProps) {
  const [stat, setStat] = useState({} as any as IHomeStat);
  useEffect(() => {
    axios.post(`${Env.basePath}/extra/visit`).then((s) => console.log(s));
    axios.get(`${Env.basePath}/extra/homeStat`).then((res) => setStat(res.data));
  }, []);
  const btnStyle = cx(
      Style.btnPrimary,
      css`
        width: 24rem;
        border: 2px solid ${transparentize(0.3, "#fff")} !important;
        background: ${transparentize(0.3, Color.main)}!important;
      `
    ),
    transparentBtnStyle = cx(
      btnStyle,
      css`
        background-color: transparent !important;
      `
    );
  const modalItemStyle = css`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    img {
      width: 10rem;
      border-radius: 50%;
    }
  `;
  return (
    <section className={style.login}>
      <div className={style.bgWrapper}>
        <video src={`${ABU}video/bg.mp4?v=1`} loop muted autoPlay className={style.bg} />
      </div>
      <header
        className={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
        `}
      >
        <div>
          <img alt="logo" src={`${ABU}img/logo.png`} />
        </div>
        <button
          className={cx(
            Style.btnPrimarySm,
            css`
              margin: unset;
              background: transparent !important;
              text-decoration: underline;
              display: none;
            `
          )}
          onClick={() =>
            Modal.info({
              ...Md.fnProps,
              width: Md.pageWidth,
              closeIcon: (
                <img
                  alt=""
                  style={{
                    height: "1.2rem",
                    position: "absolute",
                    top: "-1.5rem",
                    right: "0.5rem",
                  }}
                  src={`/MarketSearch/static//asset/img/intro_modal_close.png`}
                />
              ),
              closable: true,
              className: style.loginIntroModal,
              content: (
                <div
                  className={css`
                    font-size: 1.8rem;
                  `}
                >
                  倪得兵 王啸远 宋艳 谯涌川 李宇鹏
                </div>
              ),
            })
          }
        >
          教师团队
        </button>
      </header>
      <div className={style.main}>
        <div className={style.titleBar}>
          <div className={style.title}>
            消费者市场搜寻与
            <br />
            企业营销决策
          </div>
          <span className={style.subTitle}>虚拟仿真实验</span>
        </div>
        <div
          className={css`
            margin-top: 4rem;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 2rem;
            @media (max-width: 768px) {
              grid-template-columns: 1fr;
            }
          `}
        >
          <RegisterModal>
            <div className={transparentBtnStyle}>注册</div>
          </RegisterModal>
          <div
            className={transparentBtnStyle}
            onClick={() => {
              Modal.info({
                icon: <></>,
                width: "48rem",
                title: "账号登录",
                centered: true,
                okText: "关闭",
                content: (
                  <div
                    className={css`
                      padding: 2rem 0;
                    `}
                  >
                    <div
                      className={css`
                        margin-top: 2rem;
                        display: flex;
                        justify-content: space-around;
                      `}
                    >
                      <div className={modalItemStyle} onClick={() => (location.href = `${Env.basePath}/cas`)}>
                        <img src={`${ABU}img/school_uestc.png`} />
                        <p>电子科技大学学生</p>
                      </div>
                      <LoginModal>
                        <div className={modalItemStyle}>
                          <img src={`${ABU}img/school_other.png`} />
                          <p>其它学校学生</p>
                        </div>
                      </LoginModal>
                    </div>
                  </div>
                ),
              });
            }}
          >
            登录
          </div>
          <LoginModal>
            <div className={btnStyle}>教师登录</div>
          </LoginModal>
          <AsGuestModal>
            <div className={btnStyle}>专家评审</div>
          </AsGuestModal>
        </div>
      </div>
      <footer className={style.footer}>
        <div className={style.statistics}>
          <ul>
            <li>正在访问：&nbsp;{stat.todayVisit}</li>
            <li>历史访问：&nbsp;{stat.totalVisit}</li>
            <li>实验人数：&nbsp;{stat.resultAmount}</li>
          </ul>
        </div>
        <p
          className={css`
            text-align: center;
            @media (max-width: 768px) {
              display: none;
            }
          `}
        >
          教师团队： 倪得兵 王啸远 方佳明 谯涌川 李宇鹏
          <br />
          热线电话：028-61831033 &nbsp;&nbsp;&nbsp;&nbsp; 虚拟实验服务和支持QQ群：459797943
        </p>
        <button
          className={cx(
            Style.btnPrimarySm,
            css`
              margin: unset;
            `
          )}
          onClick={() =>
            Modal.info({
              ...Md.fnProps,
              width: Md.pageWidth,
              icon: (
                <img
                  alt=""
                  style={{
                    height: "3rem",
                    position: "absolute",
                    top: "-1.8rem",
                    left: 0,
                  }}
                  src={`${ABU}img/intro_modal_title.png?v=1`}
                />
              ),
              closeIcon: (
                <img
                  alt=""
                  style={{
                    height: "1.2rem",
                    position: "absolute",
                    top: "-1.5rem",
                    right: "0.5rem",
                  }}
                  src={`/MarketSearch/static//asset/img/intro_modal_close.png`}
                />
              ),
              closable: true,
              className: style.loginIntroModal,
              content: (
                <div
                  className={css`
                    max-height: 70vh;
                    overflow-y: auto;
                  `}
                >
                  大量市场交易中，买家与卖家无法立刻建立联系，也无法及时了解互相的需要。因为买卖双方在搜寻中都需要花费金钱、精力与时间，这些活动给市场带来了摩擦。为了更好的了解这些市场，认识市场中的搜寻活动，理解经济学、管理学中关于搜寻市场需求和供给的微观分析，电子科技大学经济管理学院整合双一流大学教学资源和学校在电子信息方向上的学科发展优势，
                  打造“消费者市场搜寻虚拟仿真实验”教学项目。通过该项目达到营销类与微观经济学教学的智能化、云端化、互动化，把消费者搜寻过程中遇到的问题通过模拟仿真的形式更好的呈现给学生，解决以往教学过程中，学生无法理解搜寻理论的生动内涵，对不同决策环境下搜寻行为特征掌握不足的缺憾。
                  <br />
                  <br />
                  “消费者市场搜寻虚拟仿真实验”教学项目适用于：行为科学研究，市场营销，消费者行为学，微观经济学，产业组织等课程的实验板块。本教学项目包括5个互动教学板块，可对应8个学时的实验经济学任务，具体包括：（1）经典搜寻，（2）进阶搜寻（卖方干扰下的搜寻），（3）外部市场波动与搜寻，（4）销售策略，（5）买卖博弈。实验中的5大板块按照线性顺序逐一展开：你将首先扮演一名消费者，在一个新的城市，展开新的生活。在这一过程中，你将通过一系列的市场搜寻任务，理解和掌握（1）经典的搜寻问题；（2）卖方干扰下的搜寻问题；（3）市场波动中的搜寻问题。通过这些任务，你将逐渐了解搜寻市场的特点，完成对搜寻市场各种现象的学习。接下来，你将成为一家公司的销售人员，并（4）在搜寻市场中制定销售策略，争取更高的收益。最终，你将（5）与其它的公司和买家之间进行竞争博弈，深入的了解市场竞争环境下，搜寻市场中的营销策略的制定问题。本项目结合生活实际，采用角色扮演的教学方法，使学生身临其境的感受搜寻市场中的策略权衡。
                  <br />
                  <br />
                  本项目的创新性体现在使用计算机算法和模拟、仿真技术实现针对搜寻市场的模拟，并允许买卖双方在互动环境下进行决策。通过真实但又保证简洁、可控、可观测的市场环境中更好的帮助学生理解搜寻市场中的现象。本实验拥有完全的软件著作权。实验适配多种终端，符合现代学生的操作习惯。可以实现单人和多人的学习模式：单人学习，人机仿真博弈；多人学习，买卖双方互动博弈。自2018年以来，电子科技大学已有1257人次学生使用该平台和软件完成了相关的实验或学习任务。
                  <br />
                  <br />
                  本项目既能向学生普及搜寻市场中的营销现象与背后的知识，也能满足研究型大学学生对于市场搜寻理论的理解和更富挑战的学习，同时本项目也有助于消费者权利的教育和普及，为消费者保护做出贡献。
                </div>
              ),
            })
          }
        >
          实验简介
        </button>
      </footer>
    </section>
  );
}
